<template>
  <div class="copy-button-container">
    <div
      class="d-inline-flex align-items-center justify-content-around bg-light border rounded p-2 px-4 w-100"
    >
      <strong class="me-2">{{ textToCopy }}</strong>
      <button
        class="btn btn-sm btn-outline-primary"
        @click="copyText"
      >
        <i class="bi bi-clipboard"></i>
        {{ buttonText }}
      </button>
    </div>

    <div
      v-if="copied"
      class="copied-balloon"
    >
      {{ $t('message.copyButton.copied') }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  textToCopy: {
    type: String,
    required: true,
  },
})

const copied = ref(false)
const buttonText = computed(() => {
  return copied.value
    ? t('message.copyButton.copied')
    : t('message.copyButton.copy')
})

const copyText = () => {
  navigator.clipboard.writeText(props.textToCopy).then(() => {
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  })
}
</script>

<style scoped>
.copy-button-container {
  position: relative;
  display: inline-block;
}

.copied-balloon {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #28a745;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 0.875rem;
  white-space: nowrap;
}

.copied-balloon::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #28a745 transparent transparent transparent;
}
</style>
